import { regexpOnlyNumber } from './regexp';

export const disableKeyButNumber = (event: KeyboardEvent, includingPoint = false) => {
    if (includingPoint && event.keyCode === 190) {
        return event.key;
    }

    if (regexpOnlyNumber(event.key) && event.code !== 'Backspace' && event.code !== 'Tab') {
        event.preventDefault();

        return false;
    }

    return event.key;
};
